/**
 * Calculate the all-in total for a policy.
 *
 * @param {Object} policy        — FIG_Policies record
 * @param {Array}  policyFees    — FIG_PolicyFees records filtered to this policy
 * @returns {number}             — sum of Premium + taxes + fees + additional fees
 */
export function calculatePolicyAllIn(policy, policyFees = []) {
  const b = getPolicyBreakdown(policy, policyFees);
  return b.premium + b.stateTax + b.stampingFee + b.inspectionFee +
    b.policyFee + b.agencyFee + b.brokerFee +
    b.additionalFees.reduce((s, f) => s + f.amount, 0);
}

/**
 * Build a breakdown of all fee components for a policy.
 */
export function getPolicyBreakdown(policy, policyFees = []) {
  const n = (v) => Number(v) || 0;
  return {
    premium: n(policy.Premium),
    stateTax: n(policy.StateTax),
    stampingFee: n(policy.StampingFee),
    inspectionFee: n(policy.InspectionFee),
    policyFee: n(policy.PolicyFee),
    agencyFee: n(policy.AgencyFee),
    brokerFee: n(policy.BrokerFee),
    additionalFees: policyFees.map(f => ({ label: f.FeeLabel || 'Fee', amount: n(f.Amount) })),
  };
}

/**
 * Collapse a breakdown into consolidated display rows: Premium and State Tax
 * stand alone, every fee component folds into a single "Fees" figure.
 * Presentation only — premium + stateTax + fees always equals the
 * itemized all-in total.
 */
export function consolidateBreakdown(breakdown) {
  const b = breakdown || {};
  const n = (v) => Number(v) || 0;
  return {
    premium: n(b.premium),
    stateTax: n(b.stateTax),
    fees: n(b.stampingFee) + n(b.policyFee) + n(b.agencyFee) + n(b.brokerFee) + n(b.inspectionFee) +
      (b.additionalFees || []).reduce((s, f) => s + n(f.amount), 0),
  };
}
